import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Avatar, Box, Center, HStack, Spinner, Text } from '@chakra-ui/react';
import { SidebarNestedNavList, SidebarNestedNavListSection } from '@src/components/sco/SidebarNestedNavList';
import { ScoTool } from '@src/graphql-types.ts';
import { gql } from '@src/lib/gql';
import { usePathname } from 'next/navigation';
import React from 'react';
export const ToolsNavList = () => {
  const $ = _c(4);
  const pathname = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    query tools {
      scoTools {
        items {
          id
          toolId
          title
          slug
          iconUrl
          toolTypeKey
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  let t1;
  if ($[1] !== pathname || $[2] !== query.data?.scoTools?.items) {
    const tools = query.data?.scoTools?.items || [];
    const appTools = tools.filter(_temp);
    const chatTools = tools.filter(_temp2);
    t1 = <Box flex={1} overflowY="auto">{tools ? <><HStack px={0} py={2}><Text color="colorPalette.fg/50" fontSize="xs" fontWeight="bold" textTransform="uppercase">Apps</Text></HStack><SidebarNestedNavList sections={appTools.map(tool_1 => mapToolToSection(tool_1, pathname))} /><HStack px={0} py={2}><Text color="colorPalette.fg/50" fontSize="xs" fontWeight="bold" textTransform="uppercase">Chat Tools</Text></HStack><SidebarNestedNavList sections={chatTools.map(tool_2 => mapToolToSection(tool_2, pathname))} /></> : <Center><Spinner /></Center>}</Box>;
    $[1] = pathname;
    $[2] = query.data?.scoTools?.items;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function mapToolToSection(tool: ScoTool, pathname: string | null): SidebarNestedNavListSection {
  const href = `/tools/${tool.slug}`;
  const isActive = !!pathname && (pathname === href || pathname.startsWith(`${href}/`));
  return {
    href,
    isActive,
    title: <HStack>
        <Avatar.Root borderRadius={'md'} size={'xs'}>
          <Avatar.Image borderRadius={'md'} src={tool.iconUrl} />
          <Avatar.Fallback borderRadius={'md'} name={tool.title} />
        </Avatar.Root>
        <Text lineClamp={1}>{tool.title}</Text>
      </HStack>
  };
}
function _temp(tool) {
  return tool.toolTypeKey === "app";
}
function _temp2(tool_0) {
  return tool_0.toolTypeKey === "chatbot";
}